export default Object.freeze({
  Or: 'or',
  And: 'and',
});
